module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 76,
	"w": 86,
	"h": 86,
	"nm": "IconCheck_NoLoop_01",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "3C Check Mark/HowItWorks_Icons_01 Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						43,
						43,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						43,
						43,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-10.027,
											1.335
										],
										[
											-2.198,
											9.165
										],
										[
											10.027,
											-9.165
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 35,
										"s": [
											0
										]
									},
									{
										"t": 55,
										"s": [
											100
										]
									}
								],
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									43.641,
									43.477
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Check",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-11.723
										],
										[
											11.723,
											0
										],
										[
											0,
											11.723
										],
										[
											-11.723,
											0
										]
									],
									"o": [
										[
											0,
											11.723
										],
										[
											-11.723,
											0
										],
										[
											0,
											-11.723
										],
										[
											11.723,
											0
										]
									],
									"v": [
										[
											21.226,
											0
										],
										[
											0,
											21.226
										],
										[
											-21.226,
											0
										],
										[
											0,
											-21.226
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 15,
										"s": [
											0
										]
									},
									{
										"t": 55,
										"s": [
											100
										]
									}
								],
								"ix": 2
							},
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 15,
										"s": [
											19
										]
									},
									{
										"t": 45,
										"s": [
											60
										]
									}
								],
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									43,
									43.477
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Circle",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											3.314,
											0
										],
										[
											0,
											0
										],
										[
											0,
											3.314
										],
										[
											0,
											0
										],
										[
											-3.314,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-3.314
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-3.314,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-3.314
										],
										[
											0,
											0
										],
										[
											3.314,
											0
										],
										[
											0,
											0
										],
										[
											0,
											3.314
										]
									],
									"v": [
										[
											24.305,
											30.305
										],
										[
											-24.305,
											30.305
										],
										[
											-30.305,
											24.305
										],
										[
											-30.305,
											-24.305
										],
										[
											-24.305,
											-30.305
										],
										[
											24.305,
											-30.305
										],
										[
											30.305,
											-24.305
										],
										[
											30.305,
											24.305
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 0,
										"s": [
											0
										]
									},
									{
										"t": 42,
										"s": [
											100
										]
									}
								],
								"ix": 2
							},
							"o": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.667
											],
											"y": [
												1
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 0,
										"s": [
											19
										]
									},
									{
										"t": 30,
										"s": [
											60
										]
									}
								],
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									43,
									43
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rectangle",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/IconCheck_NoLoop_01.json
// module id = 648
// module chunks = 0